import {RegistrationApiGet} from "./reg_api";
import {Box, Card, CardContent, CardMedia, Typography} from "@mui/material";
import useDownloadImage from "../storage/useDownloadImage";
import {Tables} from "../../apitypes";
import placeholder from "/assets/imgs/workorder.jpg";
import React from "react";
import {useNavigate} from "react-router-dom";
import RegOrderProducts from "./RegOrderProducts";


interface Props {
    reg: RegistrationApiGet,
    prodCount: number
}

export default ({reg, prodCount}: Props) => {

    const avatarUrl = useDownloadImage("products", reg.workOrder?.image_url)
    const navigate = useNavigate();
    const workOrder: Tables<"workOrder"> | null = reg.workOrder;

    console.log(reg.workTask)
    const isMandatory = (reg.WorkOrderID == null && reg.workTask?.NeedsWorkOrder === true) ||
        (prodCount > 0 && reg.ProductID == null)

    return <Card>

        <Box sx={{
            display: "flex",
            backgroundColor: isMandatory ? "error.main" : undefined
        }}>
            <CardMedia
                component="img"
                sx={{width: 120, height: 120, minWidth: 120, objectFit: "cover",}}
                image={avatarUrl || placeholder}
                alt={workOrder?.number}
                onClick={() => {
                    if (reg.Status !== "RegFinished") {
                        navigate("./work")
                    }
                }}
            />
            <CardContent sx={{flexGrow: 1}}>
                <Typography variant={"caption"}>Delovni nalog</Typography>
                <Typography variant={"h4"}>{workOrder?.number}</Typography>
                <Typography variant={"body1"}>{workOrder?.buyerName}</Typography>
                <Typography variant={"body1"} sx={{color: "error.main"}}>{workOrder?.plannedCompletionDate ? "Rok: " +  new Date(workOrder?.plannedCompletionDate).toLocaleDateString(): ""}</Typography>
            </CardContent>
        </Box>
        {
            reg.WorkOrderID &&
            <RegOrderProducts
                finished={reg.Status === "RegFinished"}
                selected={reg.ProductID}
                regid={reg.id}
                workOrderID={reg.WorkOrderID}
            />
        }
    </Card>

}
